import axios from '../../utils/axios';

export const updatePersonalizationStatus = () => axios.post('v3/personalisations/popup-shown', {});
